import React, { Component } from 'react';
import classNames from 'classnames';
import {
  IWithSettingsProps,
  withSettings,
} from '../../../../components/context/settings';
import { IWithTPAProps, withTPA } from '../../../../components/context/tpa';

import compose from '../../../../lib/utils/compose';

import HeaderImage from './HeaderImage';
import HeaderTitle from './HeaderTitle';
import HeaderAuthor from './HeaderAuthor';
import SubscribeLinks, {
  SubscribeLinksPlacement,
} from '../../../../components/ui/SubscribeLinks';
import HeaderDescription from './HeaderDescription';

import { IPodcast } from '@wix/podcasts-common/dist/podcast';
import {
  MainHeaderStyle,
  MainHeaderTextAlignment,
} from '@wix/podcasts-common/dist/settings';

import getStyle from './Header.styles';
import styles from './Header.scss';

interface IMainPageHeaderProps extends IWithSettingsProps, IWithTPAProps {
  podcast: IPodcast;
}

class MainPageHeader extends Component<IMainPageHeaderProps> {
  render() {
    const { settings, podcast, tpa } = this.props;
    const { deviceType } = tpa.params;

    const mainSettings = settings.main;

    const dynamicStyle = getStyle({
      colors: settings.colors.main,
      fonts: settings.fonts.main,
      hasImage: !!podcast.image,
      settings,
      deviceType,
    });

    const headerClassName = classNames(styles.headerContainer, {
      [styles.classicHeader]:
        mainSettings.headerStyle === MainHeaderStyle.CLASSIC,
      [styles.minimalHeader]:
        mainSettings.headerStyle === MainHeaderStyle.MINIMAL,
      [styles.alignHeaderCenter]:
        mainSettings.headerTextAlignment === MainHeaderTextAlignment.CENTER,
      [styles.alignHeaderLeft]:
        mainSettings.headerTextAlignment === MainHeaderTextAlignment.LEFT,
    });

    const subscribeLinksPlacement =
      mainSettings.headerStyle === MainHeaderStyle.MINIMAL
        ? SubscribeLinksPlacement.MainMinimalHeader
        : SubscribeLinksPlacement.MainHeader;

    return mainSettings.showHeader ? (
      <div
        className={classNames(styles.headerWrapper, dynamicStyle.headerWrapper)}
      >
        <div data-hook="main.header" className={headerClassName}>
          <div className={styles.headerImageAndTitle}>
            {mainSettings.headerStyle !== MainHeaderStyle.MINIMAL &&
              podcast.image && (
                <HeaderImage
                  className={styles.headerImageContainer}
                  src={podcast.image}
                  title={podcast.title}
                />
              )}
            <div className={styles.headerTitleContainer}>
              <HeaderTitle dynamicStyle={dynamicStyle} styles={styles}>
                {podcast.title}
              </HeaderTitle>
              {mainSettings.showHeaderAuthor && podcast.author && (
                <HeaderAuthor styles={styles} dynamicStyle={dynamicStyle}>
                  {podcast.author}
                </HeaderAuthor>
              )}
              <SubscribeLinks placement={subscribeLinksPlacement} />
            </div>
          </div>
          {mainSettings.showHeaderDescription && podcast.description && (
            <HeaderDescription
              styles={styles}
              dynamicStyle={dynamicStyle}
              description={podcast.description}
              descriptionExcerpt={podcast.descriptionExcerpt}
            />
          )}
        </div>
      </div>
    ) : null;
  }
}

export default compose(withTPA, withSettings)(MainPageHeader);
